import { VStack } from "@chakra-ui/react";
import React from "react";
import {
  PageContainer,
  PageHeadingContainer,
} from "../components/atoms/Containers";
import { PageHeading } from "../components/atoms/Headings";
import { HoldingTable } from "../components/organisms/holding/HoldingTable";
import { StatBoxes } from "../components/organisms/statBoxes/StatBoxes";
import { buildTaxReportsLink } from "../routers/routePaths";
import { useGetWallets } from "../store/actions/wallet";
import { useCurrentAccountStore } from "../store/currentAccountStore";
import { TaxReportsCard } from "./dashboard/TaxReportsCard";

export const Dashboard = () => {
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);

  const { data: walletResponses, isLoading } = useGetWallets(accountId);

  const isWalletsLoading = isLoading;

  return (
    <PageContainer>
      <PageHeadingContainer>
        <PageHeading>Dashboard</PageHeading>
      </PageHeadingContainer>

      <VStack gap={3}>
        <StatBoxes
          assetHoldings={walletResponses?.accountHoldings}
          isLoading={isWalletsLoading}
        />
        <HoldingTable
          holdings={walletResponses?.accountHoldings}
          wallets={walletResponses?.wallets}
          isLoading={isWalletsLoading}
        />
        <TaxReportsCard to={buildTaxReportsLink({ accountId })} />
      </VStack>
    </PageContainer>
  );
};
